export default (value: string): boolean => {
  return /^(?:(?:[\w`~!#$%^&*\-=+;:{}'|,?]+(?:(?:\.(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?()<>\] @]|\\"|\\\\)*"|[\w`~!#$%^&*\-=+;:{}'|,?]+))*\.[\w`~!#$%^&*\-=+;:{}'|,?]+)?)|(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?()<>\] @]|\\"|\\\\)+"))@(?:[a-zA-Z\d]+(?:\.[a-zA-Z\d]+)*|\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])$/.test(
    value
  );
};
